import { connect } from 'react-redux'
import { getRankingService } from 'services/ranking'
import Navigation from 'support/navigation'
import View from './View'
import { getBenchDropdowndatalist , getBenchCountriesList,getSearchApiBenchDatalist,getAllBenchUserDataList} from 'services/innovate/bench'

// const DEFAULT_ALL = [{ value: "ALL", label: "ALL" }];

// const normalizeToAllFormat = (items) => {
//   // If nothing / undefined / not array => force default ALL format
//   if (!Array.isArray(items) || items.length === 0) return DEFAULT_ALL;
//   return items;
// };

// const normalizeAllOption = (items, allValue = "ALL") => {
//   const selected = normalizeToAllFormat(items);
//   // If ALL selected along with others => remove ALL
//   const hasAll = selected.some((x) => x?.value === allValue);
//   if (hasAll && selected.length > 1) {
//     return selected.filter((x) => x?.value !== allValue);
//   }

//   // Else return as-is (either only ALL, or other selections without ALL)
//   return selected;
// };

// const toValueArray = (items) => (Array.isArray(items) ? items.map(x => x?.value) : []);

const mapStateToProps = state => {
  return {
    myEmail: state.data.user.userEmail,
    benchDropdownList: state.data.bench.benchDropdownList,
    benchSearchUserList: state.data.bench.benchSearchUserList,
    benchUser: state.data.bench.benchUser,
    BenchUserLoading: state.data.bench.BenchUserLoading,
    BenchDropdownListLoading: state.data.bench.BenchDropdownListLoading,
    BenchSearchListLoading: state.data.bench.BenchSearchListLoading,
    getBenchCountriesListIsLoading: state.data.bench.getBenchCountriesListIsLoading,
    getBenchCountriesList: state.data.bench.getBenchCountriesList,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getBenchDropdownDatalistFn: () => {
      dispatch(getBenchDropdowndatalist())
    },
    getBenchCountriesListFn: () => {
      dispatch(getBenchCountriesList())
    },
    getSearchApiBenchDatalistFn:(usernameSearch)=>{
        dispatch(getSearchApiBenchDatalist(usernameSearch))
    },
   
    getAllBenchUserDataList:(filterData)=>{
      const {orderDataValue,
        role,
        skill,
        country } = filterData
        // console.log("🚀 ~ filterData:", filterData)
        // console.log("🚀 ~ orderDataValue:",  Object.values(communities)[0]) 
      const filterDataWithOrderArray = Array.isArray(orderDataValue) ? orderDataValue.map((option) => option?.value) : orderDataValue?.value;
      const filterDataWithRolesArray = Array.isArray(role) ? role.map((option) => option?.value) : [];
      const filterDataWithSkillArray = Array.isArray(skill) ? skill.map((option) => option?.value) : [];
      const filterDataWithCommunitiesArray = Array.isArray(country) ? country.map((option) => option?.value) : country?.value;
        
      dispatch(getAllBenchUserDataList({filterDataWithOrderArray,
        filterDataWithRolesArray,
        filterDataWithSkillArray,
        filterDataWithCommunitiesArray }))
    }

    // getAllBenchUserDataList: (filterData) => {
    //   const { orderDataValue, role, skill, country } = filterData;
    
    //   // Normalize multi-selects so default is always [{ALL}] format
    //   const roleNormalized = normalizeAllOption(role, "ALL");
    //   const skillNormalized = normalizeAllOption(skill, "ALL");
    //   const countryNormalized = normalizeAllOption(country, "ALL");
    
    //   const filterDataWithOrderArray = Array.isArray(orderDataValue)
    //     ? orderDataValue.map((option) => option?.value)
    //     : orderDataValue?.value;
    
    //   const filterDataWithRolesArray = toValueArray(roleNormalized);
    //   const filterDataWithSkillArray = toValueArray(skillNormalized);
    //   const filterDataWithCommunitiesArray = toValueArray(countryNormalized);
    
    //   dispatch(
    //     getAllBenchUserDataList({
    //       filterDataWithOrderArray,
    //       filterDataWithRolesArray,
    //       filterDataWithSkillArray,
    //       filterDataWithCommunitiesArray,
    //     })
    //   );
    // }
     
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
